import type { BlogFilterId, BlogPostCategoryId } from '@/features/blog/types/blog.types'

// Filter chips on the listing page; ids align with `BlogPost.category` in JSON.
export const BLOG_FILTERS: { id: BlogFilterId; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'car-interior', label: 'Car Interior' },
  { id: 'car-electronics', label: 'Car Electronics' },
  { id: 'car-care', label: 'Car Care' },
  { id: 'car-utility', label: 'Car Utility' },
  { id: 'car-exterior', label: 'Car Exterior' },
  { id: 'car-audio-video', label: 'Car Audio/Video' },
]

export function blogCategoryLabel(id: BlogPostCategoryId): string {
  const entry = BLOG_FILTERS.find((f) => f.id === id)
  return entry?.label ?? id
}

export function categoryMatchesFilter(
  postCategory: BlogPostCategoryId,
  filterId: BlogFilterId,
): boolean {
  if (filterId === 'all') return true
  return postCategory === filterId
}
